<template>
  <div>
    <HeroSection />
    <ObjectivesSection />
    <HowToReportSection />
    <StatisticsSection />
  </div>
  <FooterComponent />
</template>

<script>
import HeroSection from "@/components/homeComponent/HeroSection.vue";
import ObjectivesSection from "@/components/homeComponent/ObjectivesSection.vue";
import HowToReportSection from "@/components/homeComponent/HowToReportSection.vue";
import StatisticsSection from "@/components/homeComponent/StatisticsSection.vue";
import FooterComponent from "@/components/common/Footer.vue";

export default {
  name: 'LandingPage',
  components: {
    HeroSection,
    ObjectivesSection,
    HowToReportSection,
    StatisticsSection,
    FooterComponent,
  },
};
</script>
